<template>
  <QuestionYesNo
    title="Gender"
    :question="{ options: options, designator: 'gender' }"
    :initValue="initValue"
    @input="handleChange"
  />
</template>

<script>
import QuestionYesNo from '@/components/QuestionYesNo'

export default {
  name: 'Gender',
  components: {
    QuestionYesNo
  },
  props: {
    value: {
      type: String
    },
    applicantId: {
      type: Number
    }
  },
  data () {
    return {
      options: [
        { id: 'male', text: 'male' },
        { id: 'female', text: 'female' }
      ]
    }
  },
  computed: {
    initValue () {
      return this.value ? this.value : ''
    }
  },
  methods: {
    async handleChange (data) {
      try {
        let v = data.answer
        await this.$network_utils.updateApplicant({ applicant_id: this.applicantId, gender: v })
        this.$emit('input', v)
        this.$utils.emit('show_toast', { text: 'הצלחה' })
      } catch (e) {
        console.log(e)
        this.$utils.emit('show_toast', { text: 'failed' })
      }
    }
  }
}
</script>
